import {forwardRef} from 'react'
import {InputTextField, type InputTextFieldProps} from '../input-text-field/InputTextField'

/**
 * Inherits `InputTextField`'s API — including the optional `label` and
 * `helperText` — minus `type`, which this field owns (it pins `tel` to open the
 * number pad).
 *
 * Declared by extension rather than restated: the props were previously copied
 * off `InputHTMLAttributes`, which left `label`/`helperText` unreachable through
 * the type even though the spread below already forwarded them.
 */
export interface InputNumberFieldProps extends Omit<InputTextFieldProps, 'type'> {}

export const InputNumberField = forwardRef<HTMLInputElement, InputNumberFieldProps>(
  (props, ref) => <InputTextField ref={ref} type="tel" {...props} />,
)

InputNumberField.displayName = 'InputNumberField'
